/**
 *  Arquivo que contém as constantes com os nomes padrões
 *      para store de recurso disponível da agência de fomento (financiadora)
 */
export const SET_AVAILABLE_RESOURCES = 'AVAILABLE_RESOURCES/SET_AVAILABLE_RESOURCES'
export const ADD_AVAILABLE_RESOURCES = 'AVAILABLE_RESOURCES/ADD_AVAILABLE_RESOURCES'
export const DEL_AVAILABLE_RESOURCES = 'AVAILABLE_RESOURCES/DEL_AVAILABLE_RESOURCES'
